const SWATCHES = {
  black: "#1f1f24", white: "#ffffff", pink: "#f4a6c1", "dark pink": "#e0457b", "light pink": "#f9cfdf",
  red: "#d62839", yellow: "#f6c945", peach: "#f8c8a8", "baby blue": "#a7d3f2", lilac: "#c8a2e0",
  brown: "#8b5a2b", khaki: "#c3b091", grey: "#9ca3af", "dark grey": "#4b5563", "light grey": "#d1d5db",
  "white grey": "#eceef1", denim: "#4a6fa5", "denim blue": "#4a6fa5", army: "#4b5320",
};

export const colourSwatches = (name) =>
  name.split("&").map((part) => SWATCHES[part.trim().toLowerCase()] || "#e9d5ff");

export const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

const Swatch = ({ name }) => {
  const parts = colourSwatches(name);
  const bg = parts.length > 1 ? `linear-gradient(135deg, ${parts[0]} 50%, ${parts[1]} 50%)` : parts[0];
  return <span className="w-5 h-5 rounded-full border border-gray-300 shrink-0" style={{ background: bg }} />;
};

export const ColourPicker = ({ colours, value, onChange, error }) => (
  <div className="mt-5" data-testid="colour-picker">
    <p className="text-sm font-semibold text-gray-800 mb-2">
      Choose colour <span className="text-fuchsia-600">*</span>
      {value && <span className="font-normal text-muted-foreground"> · {value}</span>}
    </p>
    <div className="flex flex-wrap gap-2">
      {colours.map((c) => (
        <button
          key={c.name}
          type="button"
          data-testid={`colour-option-${slug(c.name)}`}
          onClick={() => onChange(c)}
          className={`inline-flex items-center gap-2 pl-2 pr-4 py-2 rounded-full text-sm font-medium border transition-colors ${
            value === c.name
              ? "border-fuchsia-500 bg-fuchsia-50 text-purple-900 ring-2 ring-fuchsia-200"
              : "bg-white border-purple-200 text-purple-800 hover:border-fuchsia-400"
          }`}
        >
          <Swatch name={c.name} /> {c.name}
        </button>
      ))}
    </div>
    {error && (
      <p data-testid="colour-required-error" className="text-sm text-red-500 mt-2">
        Please choose a colour before adding to your bag.
      </p>
    )}
  </div>
);
